export const fetchAndCacheAsset = async (
  assetUrl: string,
  cacheName = "asset-cache"
): Promise<Blob | null> => {
  try {
    const cache = await caches.open(cacheName);
    const cachedResponse = await cache.match(assetUrl);

    if (cachedResponse) {
      console.log(`Loaded from cache: ${assetUrl}`);
      return await cachedResponse.blob();
    }

    const response = await fetch(assetUrl);
    if (response.ok) {
      await cache.put(assetUrl, response.clone());
      console.log(`Fetched and cached: ${assetUrl}`);
      return await response.blob();
    } else {
      console.warn(`Failed to fetch: ${assetUrl}`, response.status);
      return null;
    }
  } catch (error) {
    console.error(`Error handling asset: ${assetUrl}`, error);
    return null;
  }
};
